import type { LoggingLevel } from '@/types/LoggingLevels.ts';
import { useSettingsStore } from '@/stores/SettingsStore.ts';
import { logger } from '@/lib/logger.ts';

export const setLoggingLevelAction = (level: LoggingLevel) => {
    const settingsStore = useSettingsStore();
    settingsStore.loggingLevel = level;

    logger.level = settingsStore.loggingLevel;
};
